import { getTranspiledJobsData } from '../../data/apis/api';
import { useRestQuery } from '../../data/util';
import { QueryKey } from './config';

export const useJobsData = (transpilerId: string, isBulk?: boolean, disabled?: boolean) => {
  const data = useRestQuery(
    [QueryKey, 'getJobsTranspiledData', transpilerId],
    () => getTranspiledJobsData(transpilerId, isBulk),
    {
      retry: false,
      refetchOnMount: true,
      enabled: !!transpilerId && !disabled,
      sentryTag: 'transpiler.getJobsTranspiledData'
    }
  );

  return data;
};
